import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Timer } from './Timer'

export const EventTimer = ({ title, subtitle, finishAt, onFinish }) => {
  return (
    <Container>
      <Header>{title}</Header>
      {subtitle && <SecondaryHeader>{subtitle.toUpperCase()}</SecondaryHeader>}
      <Timer key={finishAt} finishAt={finishAt} onFinish={onFinish} />
    </Container>
  )
}

const Container = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
`

const Header = styled.h1`
  color: white;
  text-align: center;
  font-weight: 700;
  font-size: 1.938rem;
  text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
`
const SecondaryHeader = styled.span`
  color: white;
  text-align: center;
  font-weight: 700;
  font-size: 1.5rem;
  text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
`

EventTimer.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  finishAt: PropTypes.string.isRequired,
  onFinish: PropTypes.func,
}
